import { VNode, el } from "@dhx/ts-common/dom";
import { ScrollView } from "@dhx/ts-common/ScrollView";
import { List } from "./List";
import { IListConfig, IProList } from "./types";

export class ProList extends List implements IProList {
	public scrollView: ScrollView;

	constructor(container: HTMLElement | string, config?: IListConfig) {
		super(container, config);
		this.scrollView = new ScrollView(() => this.getRootView());
		this.paint();
	}

	destructor() {
		super.destructor();
		this.scrollView = null;
	}

	showItem(id: string): void {
		const rootView = this.getRootView();
		if (!rootView || !rootView.node || !rootView.node.el || typeof id === "undefined") {
			return;
		}

		const listEl: Element = this.getRootNode();
		if (!listEl) {
			return;
		}

		const virtual = this.config.virtual;
		const index = this.data.getIndex(id);
		const currentPage = Math.floor(index / listEl.children.length) || 0;
		const el = listEl.children[index - listEl.children.length * currentPage] as HTMLElement;

		if (!virtual && !el) return;
		const height = virtual ? parseInt(this.config.itemHeight as string) : el.clientHeight;
		const top = virtual ? index * height : el.offsetTop;

		if (top >= listEl.scrollTop + listEl.clientHeight - height) {
			listEl.scrollTo(0, top - listEl.clientHeight + height);
		} else if (top < listEl.scrollTop) {
			listEl.scrollTo(0, top);
		}
	}

	protected _renderList(): VNode {
		const range = this._getRange();
		// mapRange
		const data = this.data.getRawData(range[0], range[1]);
		let kids = data.map((obj, index) => this._renderItem(obj, index));

		if (this.config.virtual) {
			kids = [
				el(".div", { style: { height: range[2] + "px" } }),
				...kids,
				el(".div", { style: { height: range[3] + "px" } }),
			];
		}

		const scrollViewEnable = this.scrollView && this.scrollView.config.enable;
		const currentClass =
			(this.config.css ? this.config.css : "") +
			(this.config.multiselection && this.selection.getItem() ? " dhx_no-select--pointer" : "") +
			(scrollViewEnable ? " dhx_list--scroll-view" : "");

		return el(
			"ul.dhx_widget.dhx_list",
			{
				style: {
					"max-height": this.config.height,
					position: "relative",
				},
				class: currentClass,
				"data-dhx-widget-id": this._uid,
				...this._handlers,
				...this._getListAriaAttrs(this.config, this.data.getLength()),
			},
			scrollViewEnable ? [].concat(this.scrollView.render(kids)) : kids
		);
	}
}
